import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=3c042ae6&scoped=true&lang=pug&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c042ae6",
  null
  
)

export default component.exports